module.exports = __webpack_public_path__ + "static/img/title-cn.bd7708a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/title-cn.png
// module id = DIKA
// module chunks = 1